import { createSlice } from "@reduxjs/toolkit"

 interface initialStateI{
    serviceActived: boolean;
    loading: boolean;
    isModalOpen: boolean;
    contentSelected: 'inicio' | 'noEstoyInteresado' | 'avisoDePrivacidad' | 'confirmNumero' | 'successActive' | 'actualizarServicio' | 'cancelarServicio' | 'successInactive';
    pinSent: boolean;
    pinRequeted: number | null;
    telefonoWhatsapp: string | null;
 } 

const initialState: initialStateI = {
    serviceActived: false,
    contentSelected: "inicio",
    loading: false,
    isModalOpen: false,
    pinSent: false,
    pinRequeted: null,
    telefonoWhatsapp: null,
}

export const servicioWhatsappSlice = createSlice({
    name: 'servicioWhatsapp',
    initialState,
    reducers: {
        onServiceActive: (state, {payload}) => {
            state.serviceActived = payload;
        },
        onContentSelected: (state, {payload}) => {
            state.contentSelected = payload;
        },
        onLoading: (state, {payload}) => {
            state.loading = payload;
        },
        onModalOpen: (state, {payload}) => {
            state.isModalOpen = payload;
        },
        onPinSent: (state, {payload}) => {
            state.pinSent = payload;
        },
        onPinReceived: (state, {payload}) => {
            state.pinRequeted = payload;
        },
        onTelefonoWhatsapp: (state, {payload}) => {
            state.telefonoWhatsapp = payload;
        },
    },
});

export const { onServiceActive, onContentSelected, onLoading, onModalOpen, onPinSent, onPinReceived, onTelefonoWhatsapp } = servicioWhatsappSlice.actions;